export enum PersonTypes {
    Accounting = "Accounting",
    Administration = "Administration",
    Asn = "ASN",
    AssociateMedicalDirector = "Associate Medical Director",
    Attorney = "Attorney",
    CeoPresident = "CEO/President",
    Chaplain = "Chaplain",
    ChiefClinicalOfficer = "Chief Clinical Officer",
    ChiefNursingOfficer = "Chief Nursing Officer",
    ChiefOperatingOfficer = "Chief Operating Officer",
    CoMedicalDirector = "Co-Medical Director",
    CommunityOutreach = "Community Outreach",
    Coroner = "Coroner",
    DepartmentClerk = "Department Clerk",
    DeputyDirector = "Deputy Director",
    Director = "Director",
    DoctorSurgeon = "Doctor/Surgeon (MD)",
    Ebaa = "EBAA",
    Educator = "Educator",
    EyeBank = "Eye Bank",
    FamilyCareOrgan = "Family Care-Organ",
    FamilyCareTissue = "Family Care-Tissue",
    FamilyCareSpecialist = "Family Care Specialist",
    FHDirector = "FH Director",
    Finance = "Finance",
    Hospice = "Hospice",
    IdConsultant = "ID Consultant",
    Investigator = "Investigator",
    LPN = "LPN",
    MedicalAdvisoryBoard = "Medical Advisory Board",
    MedicalDirector = "Medical Director",
    MedicalExaminer = "Medical Examiner",
    MedicalRecords = "Medical Records",
    Nurse = "Nurse (RN)",
    OcularDistribution = "Ocular Distribution",
    Ophthalmologist = "Ophthalmologist",
    OrganCoordinator = "Organ Coordinator",
    OrganRecovery = "Organ Recovery",
    PatientCare = "Patient Care",
    Physician = "Physician",
    PoliceOfficer = "Police Officer",
    President = "President",
    PrincipleInvestigator = "Principle Investigator",
    Professor = "Professor",
    PurchasingAgent = "Purchasing Agent",
    Reception = "Reception",
    RecoveryTech = "Recovery Tech",
    Researcher = "Researcher",
    Resident = "Resident",
    RiskManagement = "Risk Management",
    Scheduler = "Scheduler",
    Secretary = "Secretary",
    Security = "Security",
    SocialWorker = "Social Worker",
    Surgery = "Surgery (non-surgeons)",
    SurgeryScheduler = "Surgery Scheduler",
    Technician = "Technician",
    TissueRecoveryTech = "Tissue Recovery Tech",
}
